/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'

import React from 'react'

interface PropsType {
	children?: string | number
	style?: React.CSSProperties
}

export const Label = styled.label(
	{
		position: 'relative',
		display: 'block',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		left: 0,
		top: 0,
		padding: 0,
		color: 'rgba(0, 0, 0, 0.6)',
		textOverflow: 'ellipsis',
		fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
		fontWeight: '400',
		fontSize: '12px',
		lineHeight: '1.4375em',
		letterSpacing: '0.00938em',
	},
	(props: PropsType) => {
		return { ...props.style }
	},
)
